var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { UrlHelper } from '../../../helper/UrlWrapper';
import StockInitService from '../../../api/StockInitService';
import SalesReportService from '../../../api/SalesReportService';
import { EReportCustomerFrom, EReportCustomerType } from '../../../enum/EReportCustomerFrom';
import ExportResult from './ExportResult.vue';
import AreaShop from '@/components/AreaShop';
var initFormData = {
    viewType: 0,
    from: '',
    order_type: 1,
    time_type: 1,
    business_keywords: '',
    s_time: new Date(Date.now() - 7 * 24 * 3600 * 1000),
    e_time: new Date(),
};
function getTheDayZeroTime(date) {
    var d = new Date(date);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d.getTime();
}
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.type = [
            {
                id: 1,
                label: '单号',
            },
            {
                id: 2,
                label: '货品',
            },
        ];
        _this.isMoreSearch = false;
        _this.treeData = [];
        _this.viewTypeOtions = [
            { id: 0, label: '按门店查看' },
            { id: 1, label: '按出库仓库查看' },
            { id: 2, label: '按货品类别查看' },
            { id: 3, label: '按货品查看' },
        ];
        _this.customerSourceOptions = EReportCustomerType;
        _this.orderTypeOptions = [
            { id: 1, label: '销售-退货' },
            { id: 2, label: '销售' }
        ];
        _this.dateTypeOptions = [
            { id: 1, label: '审核日期' },
            { id: 2, label: '制单日期' },
            { id: 3, label: '收货日期' },
            { id: 4, label: '到货日期' },
        ];
        _this.startPickerOptions = {
            disabledDate: function (time) {
                var now_time = new Date();
                var e_time = new Date();
                if (e_time) {
                    return !(time.getTime() <= getTheDayZeroTime(now_time) && time.getTime() <= getTheDayZeroTime(e_time));
                }
                else {
                    return !(time.getTime() <= getTheDayZeroTime(now_time));
                }
            },
        };
        _this.endPickerOptions = {
            disabledDate: function (time) {
                var now_time = new Date();
                var s_time = new Date(Date.now() - 7 * 24 * 3600 * 1000);
                if (s_time) {
                    return !(time.getTime() <= getTheDayZeroTime(now_time) && time.getTime() >= getTheDayZeroTime(s_time));
                }
                else {
                    return !(time.getTime() <= getTheDayZeroTime(now_time));
                }
            },
        };
        _this.exportModalVisbile = false;
        _this.exportType = 1;
        return _this;
    }
    BillHeader.prototype.watchFormData_ViewType = function () {
        this.computedOrderOptions();
    };
    BillHeader.prototype.watchFormData_from = function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.computedOrderOptions();
        }
    };
    BillHeader.prototype.created = function () {
        this.computedOrderOptions();
        this.service = StockInitService.getInstance();
        this.SalesReportService = SalesReportService.getInstance();
        if (!this.openedCodeData.isOrderService) {
            this.customerSourceOptions = this.customerSourceOptions.filter(function (v) { return v.label != '自主添加'; });
        }
    };
    BillHeader.prototype.mounted = function () {
        this.getOrgandepotOptions();
        this.search();
    };
    BillHeader.prototype.getPlaceholder = function () {
        switch (this.formData.viewType) {
            case 0:
                return '请输入门店或者客户关键字进行查询';
            case 1:
                return '请输入出库仓库关键字进行查询';
            case 2:
                return '请输入货品类别关键字进行查询';
            case 3:
                return '请输入货品关键字进行查询';
        }
    };
    BillHeader.prototype.computedOrderOptions = function () {
        var newVal = this.formData.from;
        switch (newVal) {
            case EReportCustomerFrom['供应链']:
                this.orderTypeOptions = [
                    { id: 1, label: '客户入库' },
                    { id: 2, label: '客户入库-客户退货' },
                ];
                this.formData.order_type = 2;
                this.dateTypeOptions = [
                    { id: 1, label: '审核日期' },
                    { id: 2, label: '制单日期' },
                    { id: 3, label: '收货日期' },
                    { id: 4, label: '到货日期' },
                ];
                this.formData.time_type = 1;
                break;
            case EReportCustomerFrom['商城']:
                this.orderTypeOptions = [
                    { id: 3, label: '送货' },
                    { id: 4, label: '送货退货' },
                ];
                this.formData.order_type = 4;
                this.dateTypeOptions = [
                    { id: 1, label: '审核日期' },
                    { id: 2, label: '制单日期' },
                    { id: 3, label: '收货日期' },
                    { id: 4, label: '到货日期' },
                ];
                this.formData.time_type = 1;
                break;
            case EReportCustomerFrom['自主添加']:
                this.orderTypeOptions = [
                    { id: 2, label: '送货' },
                    { id: 1, label: '送货-退货' },
                ];
                this.formData.order_type = 1;
                this.dateTypeOptions = [
                    { id: 1, label: '审核日期' },
                    { id: 2, label: '制单日期' },
                    { id: 4, label: '到货日期' },
                ];
                this.formData.time_type = 1;
                break;
            default:
                this.orderTypeOptions = [
                    { id: 1, label: '销售-退货' },
                    { id: 2, label: '销售' }
                ];
                if ([0, 1, 2].includes(this.formData.viewType)) {
                    this.orderTypeOptions.push({ id: 5, label: '退货' });
                }
                this.formData.order_type = 1;
                this.dateTypeOptions = [
                    { id: 1, label: '审核日期' },
                    { id: 2, label: '制单日期' },
                    { id: 3, label: '收货日期' },
                    { id: 4, label: '到货日期' },
                ];
                this.formData.time_type = 1;
                break;
        }
    };
    BillHeader.prototype.search = function () {
        if (localStorage.getItem("ToSalesSummary")) {
            this.formData.s_time = new Date(Date.now() - 30 * 24 * 3600 * 1000);
            localStorage.removeItem("ToSalesSummary");
        }
        this.$emit('search', __assign({}, this.formData));
    };
    BillHeader.prototype.getOrgandepotOptions = function () {
        var _this = this;
        this.service.getOrgandepotOptions().then(function (res) {
            if (res.data.success) {
                var data = res.data.data.map(function (item) {
                    var children = item.children &&
                        item.children.length > 0 &&
                        item.children.map(function (child) {
                            return __assign({}, child);
                        });
                    return __assign({}, item, { depot_id: item.organ_id + '_organ_id', depot_name: item.organ_name, children: children });
                });
                _this.treeData = data;
            }
        });
    };
    BillHeader.prototype.exportResult = function () {
        if (this.formData.viewType) {
            this.exportModalVisbile = true;
        }
        else {
            this.exportData();
        }
    };
    BillHeader.prototype.exportData = function (isDepotSearch) {
        if (isDepotSearch === void 0) { isDepotSearch = false; }
        var url = 'supplierclientapi/sale_report_summary/export?';
        if (isDepotSearch) {
            if (this.formData.viewType == 1) {
                url = "/supplierclientapi/sale_report_summary/export_depot";
                url = UrlHelper.addParam(url, 'type', this.exportType);
            }
            if (this.formData.viewType == 2) {
                url = "/supplierclientapi/sale_report_summary/export_goods_type";
                url = UrlHelper.addParam(url, 'type', this.exportType);
            }
            if (this.formData.viewType == 3) {
                url = "/supplierclientapi/sale_report_summary/export_by_goods";
                url = UrlHelper.addParam(url, 'type', this.exportType);
            }
        }
        url = UrlHelper.addParam(url, 'from', this.formData.from);
        url = UrlHelper.addParam(url, 'order_type', this.formData.order_type);
        url = UrlHelper.addParam(url, 'time_type', this.formData.time_type);
        url = UrlHelper.addParam(url, 's_time', this.formData.s_time.format('yyyy-MM-dd'));
        url = UrlHelper.addParam(url, 'e_time', this.formData.e_time.format('yyyy-MM-dd'));
        url = UrlHelper.addParam(url, 'business_keywords', this.formData.business_keywords);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
    };
    BillHeader.prototype.normalizer = function (node) {
        return {
            id: node.depot_id,
            label: node.depot_name,
            children: node.children,
        };
    };
    __decorate([
        Watch('formData.viewType')
    ], BillHeader.prototype, "watchFormData_ViewType", null);
    __decorate([
        Watch('formData.from')
    ], BillHeader.prototype, "watchFormData_from", null);
    BillHeader = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
            })),
            components: {
                areaShop: AreaShop,
                ExportResult: ExportResult,
            },
            watch: {
                'formData.s_time': function (newVal, oldVal) {
                    this.endPickerOptions = {
                        disabledDate: function (time) {
                            var now_time = new Date();
                            var s_time = new Date(newVal);
                            if (s_time) {
                                return !(time.getTime() <= getTheDayZeroTime(now_time) && time.getTime() >= getTheDayZeroTime(s_time));
                            }
                            else {
                                return !(time.getTime() <= getTheDayZeroTime(now_time));
                            }
                        },
                    };
                },
                'formData.e_time': function (newVal, oldVal) {
                    this.startPickerOptions = {
                        disabledDate: function (time) {
                            var now_time = new Date();
                            var e_time = new Date(newVal);
                            if (e_time) {
                                return !(time.getTime() <= getTheDayZeroTime(now_time) && time.getTime() <= getTheDayZeroTime(e_time));
                            }
                            else {
                                return !(time.getTime() <= getTheDayZeroTime(now_time));
                            }
                        },
                    };
                },
            },
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
